<div class="add-domain" [formGroup]="addDomainsFormGroup">
    <app-popup-top-line></app-popup-top-line>
    <div class="add-domain-header">
        <div class="title">
            {{ "policyPage.config.trustedDomainsContent.addDomain" | labelsProvider }}
        </div>
        <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
    </div>
    <div class="add-domain-body" formArrayName="domainsToAdd">
        <div class="input" *ngFor="let control of domainsToAdd.controls; let i = index" [formGroupName]="i">
            <input type="text" formControlName="domain" placeholder="{{ 'policyPage.config.trustedDomainsContent.enterDomain' | labelsProvider }}" />
            <img *ngIf="i > 0" src="assets/images/common/cancel.svg" (click)="removeDomain(i)" />
        </div>

        <div class="add-more" (click)="addMoreClicked()">
            <img class="add-more-img" src="assets/images/common/plus.svg" />
            <div class="add-domain-button-title">
                {{ "policyPage.config.trustedDomainsContent.addMore" | labelsProvider }}
            </div>
        </div>
    </div>
    <div class="add-domain-footer">
        <button class="cancel" (click)="onClose()">
            {{ "common.cancel" | labelsProvider }}
        </button>
        <button
            class="confirm"
            [ngClass]="{
                'confirm-disabled': addDomainsFormGroup.invalid || waitingForResponse,
            }"
            (click)="addDomains()"
            cdkFocusInitial>
            <span *ngIf="!waitingForResponse">{{ "common.add" | labelsProvider }}</span>
            <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate"> </mat-progress-spinner>
        </button>
    </div>
</div>
